
export interface Contact {
	NAME?: string;
	EMAIL?: string;
	PHONE?: string;
}

export enum CONTACT {

    NAME = "Zoe For All Nations",
    INFO_EMAIL = "info@zoeforallnations.com",
    CONTACT_NUMBER = "201201971017",
    CONTACT_NAME = "Zoe For All Nations"
}

export const CONTACT_EN = {
	NAME: CONTACT.NAME,
	EMAIL: CONTACT.INFO_EMAIL,
	PHONE: CONTACT.CONTACT_NUMBER,
};

export const CONTACT_AR = {
	NAME: "زوي لكل الأمم",
	EMAIL: CONTACT.INFO_EMAIL,
	PHONE: CONTACT.CONTACT_NUMBER,
};
